import { Link } from "react-router-dom";
import { BookOpen, Mail, Twitter, Instagram, Facebook, Heart } from "lucide-react";

const Footer = () => {
  const footerLinks = {
    features: [
      { label: "How It Works", to: "/how-it-works" },
      { label: "AI Illustrations", to: "/ai-illustrations" },
      { label: "Custom Characters", to: "/custom-characters" },
      { label: "Art Styles", to: "/art-styles" },
      { label: "Reading Experience", to: "/reading-experience" }
    ],
    resources: [
      { label: "For Parents", to: "/for-parents" },
      { label: "For Educators", to: "/for-educators" },
      { label: "Story Starters", to: "/story-starters" },
      { label: "Blog", to: "/blog" },
      { label: "FAQ", to: "/faq" },
      { label: "Contact", to: "/contact" }
    ],
    company: [
      { label: "About Us", to: "/about" },
      { label: "Pricing", to: "/pricing" },
      { label: "Testimonials", to: "/testimonials" },
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms of Service", to: "/terms" }
    ],
    partners: [
      { label: "Become an Affiliate", to: "/affiliate-apply" },
      { label: "Affiliate Resources", to: "/affiliate-resources" },
      { label: "Refer a Friend", to: "/referrals" }
    ]
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-violet-500 to-amber-500 flex items-center justify-center">
                <BookOpen className="w-5 h-5 text-white" />
              </div>
              <span className="font-bold text-lg">StoryWeaver</span>
            </Link>
            <p className="text-slate-400 text-sm mb-4">
              Creating magical, personalized storybooks that make every child the hero of their own adventure.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-slate-800 flex items-center justify-center hover:bg-slate-700 transition-colors">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-slate-800 flex items-center justify-center hover:bg-slate-700 transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-slate-800 flex items-center justify-center hover:bg-slate-700 transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Features */}
          <div>
            <h4 className="font-bold mb-4 text-white">Features</h4>
            <ul className="space-y-2">
              {footerLinks.features.map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="text-slate-400 text-sm hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-bold mb-4 text-white">Resources</h4>
            <ul className="space-y-2">
              {footerLinks.resources.map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="text-slate-400 text-sm hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-bold mb-4 text-white">Company</h4>
            <ul className="space-y-2">
              {footerLinks.company.map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="text-slate-400 text-sm hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Partners / Affiliates */}
          <div>
            <h4 className="font-bold mb-4 text-white flex items-center gap-2">
              <Heart className="w-4 h-4 text-pink-400" />
              Partners
            </h4>
            <ul className="space-y-2">
              {footerLinks.partners.map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="text-slate-400 text-sm hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="text-slate-500 text-xs mt-4">
              Earn 20% commission on referrals!
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} StoryWeaver Kids. All rights reserved.
          </p>
          <div className="flex items-center gap-2 text-slate-400 text-sm">
            <Mail className="w-4 h-4" />
            <a href="mailto:hello@storyweaverkids.com" className="hover:text-white transition-colors">
              hello@storyweaverkids.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
